import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Kicker, scrollToId } from "./shared";

const PRODUCTS = [
  {
    name: "BeanGo Cube® X",
    desc: "Chytrá pražička kávy pro domov i kavárnu.",
    img: "/img/prd-cube-x.jpeg",
    alt: "BeanGo Cube X — chytrá pražička kávy",
  },
  {
    name: "BeanGo Cube® X Pro",
    desc: "Novinka pro náročnější pražení.",
    img: "/img/machine-dark.jpeg",
    alt: "BeanGo Cube X Pro",
  },
  {
    name: "BeanGo Cube® CoolBean",
    desc: "Chladič zrn pro dokonalou chuť.",
    img: "/img/prd-coolbean.jpeg",
    alt: "BeanGo Cube CoolBean — chladicí příslušenství",
  },
];

export default function Products() {
  return (
    <section id="produkty" className="relative border-t border-stone-200 bg-[#FAF7F2] py-24 sm:py-32" data-testid="products-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <Kicker>Produkty a dostupnost</Kicker>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl md:text-5xl">
              Co u nás dostanete
            </h2>
            <p className="mt-6 text-base leading-relaxed text-stone-600 sm:text-lg">
              Jako výhradní dovozci pro ČR a SR zajišťujeme dovoz, předvedení i podporu
              celé řady BeanGo Cube®.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid gap-10 md:grid-cols-3">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1}>
              <figure className="group text-center" data-testid={`product-card-${i}`}>
                <div className="overflow-hidden rounded-lg border border-stone-200 bg-white shadow-sm">
                  <img
                    src={p.img}
                    alt={p.alt}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
                  />
                </div>
                <figcaption className="mt-5">
                  <h3 className="font-display text-lg font-bold text-stone-900">{p.name}</h3>
                  <p className="mt-1 text-sm text-stone-500">{p.desc}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-16 text-center">
            <p className="text-sm uppercase tracking-[0.2em] text-stone-500">Cenu a dostupnost vám rádi upřesníme osobně</p>
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.96 }}
              onClick={() => scrollToId("#form")}
              className="mt-6 inline-flex items-center gap-3 rounded-full bg-stone-900 px-8 py-4 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors duration-300 hover:bg-stone-700"
              data-testid="products-cta"
            >
              Chci nabídku
              <ArrowRight className="h-4 w-4" />
            </motion.button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
